import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { MatTableModule, MatPaginatorModule, MatSortModule, MatSnackBarModule, MatNativeDateModule, MatInputModule, MatProgressBarModule } from '@angular/material';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MaterializeModule } from 'angular2-materialize';
import { UtilsService } from './shared/utils-service';

import { AppComponent } from './app.component';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { routing } from './app.routing';
import { usersRouting } from "./users/users.routing";
import { telcoAuditTrailRouting } from "./telco-audit-trail/telco-audit-trail.routing";
import { UsersModule } from "./users/users.module";
import { TelcoModule } from "./telco/telco.module";
import { MassSearchCustomersComponent } from './mass-search-customers/mass-search-customers.component';
import { TemplateUploadComponent } from './mass-search-customers/template-upload/template-upload.component';
import { MenuComponent } from './menu/menu.component';
import { CustomerComponent } from './customer/customer.component';
import { CustomerDetailsComponent } from './customer-details/customer-details.component';
import { SubmitTelcoComponent } from './submit-telco/submit-telco.component';
import { MassSubmitTelcoComponent } from './mass-submit-telco/mass-submit-telco.component';
import { TelcoAuditTrailComponent } from './telco-audit-trail/telco-audit-trail.component';
// import { TelcoComponent } from './telco/telco.component';
import { SingleSubmissionHistoryComponent } from './telco-audit-trail/single-submission-history/single-submission-history.component';
import { MassSubmissionHistoryComponent } from './telco-audit-trail/mass-submission-history/mass-submission-history.component';
import { MassSearchCustomersHistoryComponent } from './telco-audit-trail/mass-search-customers-history/mass-search-customers-history.component';
import { ActivityHistoryComponent } from './telco-audit-trail/activity-history/activity-history.component';
import { ManageUsersComponent } from './manage-users/manage-users.component';
import { ChangePasswordComponent } from './manage-users/change-password/change-password.component';
import { ChangePasswordOthersComponent } from './manage-users/change-password-others/change-password-others.component';
import { ViewUserComponent } from './manage-users/view-user/view-user.component';
import { ManageUsersService } from './manage-users/manage-users.service';
import { BatchUploadComponent } from './mass-submit-telco/batch-upload/batch-upload.component';
import { BatchUploadServiceService } from './mass-submit-telco/batch-upload/batch-upload.service';
import { BatchUploadHistoryComponent } from './mass-submit-telco/batch-upload-history/batch-upload-history.component';
import { BatchUploadHistoryService } from './mass-submit-telco/batch-upload-history/batch-upload-history.service';
import { BatchUploadStatusComponent } from './mass-search-customers/batch-upload-status/batch-upload-status.component';
import { LoginLayoutComponent } from './login-layout/login-layout.component';
import { HomeLayoutComponent } from './home-layout/home-layout.component';
import { EnquiryHistoryByOtherComponent } from './telco-audit-trail/enquiry-history-by-other/enquiry-history-by-other.component';
import { FooterComponent } from './footer/footer.component';
import { CompanyComponent } from './company/company.component';
import { BranchComponent } from './branch/branch.component';


@NgModule({
  declarations: [
    AppComponent,
    NavBarComponent,
    HomeComponent,
    LoginComponent,
    NotFoundComponent,
    MenuComponent,
    CustomerComponent,
    CustomerDetailsComponent,
    MassSearchCustomersComponent,
    TemplateUploadComponent,
    SubmitTelcoComponent,
    MassSubmitTelcoComponent,
    TelcoAuditTrailComponent,
    SingleSubmissionHistoryComponent,
    MassSubmissionHistoryComponent,
    MassSearchCustomersHistoryComponent,
    ActivityHistoryComponent,
    ManageUsersComponent,
    ChangePasswordComponent,
    ChangePasswordOthersComponent,
    ViewUserComponent,
    BatchUploadComponent,
    BatchUploadHistoryComponent,
    BatchUploadStatusComponent,
    LoginLayoutComponent,
    HomeLayoutComponent,
    EnquiryHistoryByOtherComponent,
    FooterComponent,
    CompanyComponent,
    BranchComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    MaterializeModule,
    UsersModule,
    TelcoModule,
    usersRouting,
    telcoAuditTrailRouting,
    routing,
    BrowserAnimationsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSnackBarModule,
    MatNativeDateModule,
    MatInputModule,
    MatProgressBarModule
  ],
  providers: [ManageUsersService, BatchUploadServiceService, BatchUploadHistoryService, UtilsService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts